import { useResizeObserver } from '@vueuse/core'
import { Ref, ref } from 'vue'

interface Options {
    rowCount: number
    headerHeight: number
}

export function useCalculatedRowHeight(
    element: Ref<HTMLElement | undefined>,
    options: Options,
): Ref<number | undefined> {
    const rowHeight = ref<number | undefined>(undefined)

    useResizeObserver(element, () => {
        if (element.value) {
            const height = element.value.clientHeight - options.headerHeight
            rowHeight.value = Math.max(1, Math.floor(height / options.rowCount))
        }
    })

    return rowHeight
}
